import {
  AUTH_RESET_PASSWORD_FAILURE,
  AUTH_RESET_PASSWORD_SUCCESS
} from './actions';

import createReducer from 'state/createReducer';

import _ from 'lodash';

const initialState = {
  request: false,
  requestSent: false,
  validation: {
    email: '',
  }
}

const handlers = {

  [AUTH_RESET_PASSWORD_SUCCESS](state) {
    return {
      ...state,
      requestSent: true
    }
  },

  [AUTH_RESET_PASSWORD_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      validation: {
        email: _.get(payload, 'email', ''),
      }
    }
  }
}

export default (state = initialState, action) => createReducer(state, action, handlers);
